import { request } from "./request";
import { getPharmacyPayload, ListPharmacyPayload, ListPharmacyReturn, PharmacyInfo } from "@/api/types";

export async function getPharmaciesAPI(payload: ListPharmacyPayload): Promise<ListPharmacyReturn> {
  return await request<ListPharmacyReturn>({
    url: "/premium/pharmacy/list",
    method: "POST",
    data: payload,
  });
}

export async function getPharmacyAPI(payload: getPharmacyPayload): Promise<PharmacyInfo> {
  return await request<PharmacyInfo>({
    url: "/pharmacy/get",
    method: "POST",
    data: payload,
  });
}

// This API was used before migrating to react-query.
export async function listPharmacyAPI(payload: ListPharmacyPayload): Promise<ListPharmacyReturn> {
  return await request({
    url: "/pharmacy/list",
    method: "POST",
    data: payload,
  });
}
